import ToastMessage from '@/components/toasts/ToastMessage';
import tenant from '@/services/TenantService';
import useTenantStore from '@/store/tenant';
import { toast } from 'react-toastify';

export default function useTenantDelete(schema) {
  const { remove } = useTenantStore();

  const mutationFn = async (id) => {
    const { data: res } = await tenant.delete(`${schema}/${id}`);
    return { res, id };
  };

  const onSuccess = (result, id) => {
    remove(id, schema);

    toast.success(
      <ToastMessage
        title="Objekt gelöscht"
        subtitle="Die Daten wurden erfolgreich gelöscht."
      />,
    );
    return result;
  };

  const onError = (error) => {
    toast.error(
      <ToastMessage title="Fehler beim Speichern" subtitle={error?.message} />,
    );
  };

  const mutateAsync = (data) => {
    return mutationFn(data).then(({ res, id }) => onSuccess(res, id), onError);
  };

  return { mutateAsync };
}
